import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IAgent, setFilteredAgent } from "../../store/siteWebSlice";


const SearchBar = () => {


  const dispatch = useDispatch();
  const { agents } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState<string>("");


  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setFilteredAgent([...agents]));
    } else {
      const result: any = agents.filter(
        (item: IAgent, index: number) => {
          const value: any = `${item.nomAgent}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredAgent(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
